import { render } from "./VehicleView.vue?vue&type=template&id=170cce48&scoped=true"
import script from "./VehicleView.vue?vue&type=script&lang=js"
export * from "./VehicleView.vue?vue&type=script&lang=js"

import "./VehicleView.vue?vue&type=style&index=0&id=170cce48&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-170cce48"]])

export default __exports__